import React from 'react';

import { useIntl } from 'react-intl';

import { DestructuredBurgerSvg } from 'components/svgs/destructured-burger';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';

import {
  MenuEmptyStateContainer,
  MenuEmptyStateImageWrapper,
  MenuEmptyStateMessage,
  MenuEmptyStateTitle,
} from './styled';

export const MenuEmptyState = ({ logWhenTrue = false }: { logWhenTrue: boolean }) => {
  const { formatMessage } = useIntl();
  const isMobile = useIsMobileBreakpoint();
  const title = formatMessage({ id: 'menuEmptyScreenTitle' });
  const message = formatMessage({
    id: isMobile ? 'menuEmptyScreenMessage' : 'menuEmptyScreenDesktopMessage',
  });

  useLogUserErrorMessage({
    logWhenTrue,
    message: 'Menu data is empty, displaying empty state',
    severity: LogUserErrorSeverity.Recoverable,
  });

  return (
    <MenuEmptyStateContainer>
      <MenuEmptyStateImageWrapper>
        <DestructuredBurgerSvg width={'full'} />
      </MenuEmptyStateImageWrapper>
      <MenuEmptyStateTitle>{title}</MenuEmptyStateTitle>
      <MenuEmptyStateMessage>{message}</MenuEmptyStateMessage>
    </MenuEmptyStateContainer>
  );
};
